import React, { Component } from "react";
import DeleteDialog from "../../components/DeleteDialog";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import { languages } from "../../constants/languages";

class DeleteAdminContainer extends Component {
  state = {
    open: false
  };

  toggleDialog = () => {
    this.setState({ open: !this.state.open });
  };

  handleDelete = () => {
    let batch = window.firebase.firestore().batch();
    const tournamentRef = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);

    const adminRef = tournamentRef
      .collection("admins")
      .doc(this.props.admin.id);

    let admins = this.props.tournament.admins;
    admins.splice(admins.indexOf(this.props.admin.id), 1);
    batch.update(tournamentRef, { admins: admins });
    batch.delete(adminRef);
    batch.commit();
  };

  render() {
    return (
      <div>
        <IconButton
          aria-label="Change"
          onClick={this.toggleDialog}
          disabled={this.props.disabled}
          style={{ height: 30, width: 30 }}
        >
          <DeleteIcon
            style={{ height: 20, width: 20, position: "absolute", top: 5 }}
          />
        </IconButton>
        <DeleteDialog
          open={this.state.open}
          toggleDialog={this.toggleDialog}
          handleDelete={this.handleDelete}
          errorMessage={this.state.errorMessage}
          title={languages.admins.deleteAdmin}
          description={languages.admins.deleteWarning}
        />
      </div>
    );
  }
}

export default DeleteAdminContainer;
